import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-333bd3f5")

_pushScopeId("data-v-333bd3f5")
const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Permission", -1)
const _hoisted_3 = { class: "settings-row switch-row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" or  ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" permission ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.action.permission = $event))
      }, null, 512), [
        [_vModelText, _ctx.action.permission]
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("span", {
        class: ["label", _ctx.action.add ? 'active' : ''],
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.action.add = true))
      }, "ADD", 2),
      _hoisted_4,
      _createVNode("span", {
        class: ["label", !_ctx.action.add ? 'active' : ''],
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.action.add = false))
      }, "REMOVE", 2),
      _hoisted_5
    ])
  ]))
})